// extracted by mini-css-extract-plugin
export var divider = "_k2-0";
export var systemMessage = "_k2-1";
export var systemMessageWrapper = "_k2-2";